import styled from '@emotion/styled'

import { Button, spacing } from 'main/ui'

export const ParentSmallContainer = styled.div`
  margin-bottom: ${spacing.majorScale(2)}px;
`
export const DirectorContainer = styled.div`
  margin-bottom: ${spacing.majorScale(3)}px;
`
export const ParentContainer = styled.div`
  margin-bottom: ${spacing.majorScale(4)}px;
`
export const StyledButton = styled(Button)`
  margin-bottom: ${spacing.majorScale(2)}px;
`
